import * as Yup from 'yup'

const editorValidation = Yup.object({
  value: Yup.string().required('Text is required'),
})

export default { editorValidation }
